module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.semesterCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "semesterCode", $$v)
      },
      expression: "queryForm.semesterCode"
    }
  }, _vm._l((_vm.comboOption.semester), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.stuAuthVisible),
      expression: "!stuAuthVisible"
    }],
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.stuAuthVisible),
      expression: "!stuAuthVisible"
    }],
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "班级名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.className),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "className", $$v)
      },
      expression: "queryForm.className"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.comboOption.auditState), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), (_vm.stuAuthVisible) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 添加")]) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "数据加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "cell-style": _vm.handleCellStyle,
      "highlight-current-row": "",
      "height": _vm.mainTableHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.queryForm.pageNum - 1) * _vm.queryForm.rowNum + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学年学期名称",
      "prop": "semesterName",
      "align": "center",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学号",
      "prop": "stuCode",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "stuName",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "班级名称",
      "prop": "className",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课题名称",
      "prop": "projectName",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交状态",
      "prop": "submitState",
      "formatter": _vm.submitStateFormatter,
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "prop": "auditState",
      "formatter": _vm.auditStateFormatter,
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.stuAuthVisible && scope.row.submitState == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.editRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                ")]) : _vm._e(), _vm._v(" "), (_vm.stuAuthVisible && scope.row.submitState == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.delRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\n                ")]) : _vm._e(), _vm._v(" "), ((!_vm.stuAuthVisible && scope.row.auditAuth == '0') || (_vm.stuAuthVisible && scope.row.submitState == '1')) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 详情\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.auditAuth == '1') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.auditRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 审核\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.submitState == '1' || scope.row.auditState != '') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showAuditList(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document"
        }), _vm._v(" 审核信息\n                ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.queryForm.rowNum,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "800px",
      "top": _vm.dialogTop,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-form', {
    ref: "curdForm",
    staticClass: "small-space",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "model": _vm.curdForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "110px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.operateAreaVisible),
      expression: "operateAreaVisible"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学号",
      "prop": "stuCode"
    }
  }, [_vm._v(_vm._s(_vm.queryForm.stuCode))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "stuName"
    }
  }, [_vm._v(_vm._s(_vm.queryForm.stuName))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学年学期",
      "prop": "semesterCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.semesterCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "semesterCode", $$v)
      },
      expression: "curdForm.semesterCode"
    }
  }, _vm._l((_vm.comboOption.semester), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课题名称",
      "prop": "projectName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写课题名称"
    },
    model: {
      value: (_vm.curdForm.projectName),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "projectName", $$v)
      },
      expression: "curdForm.projectName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设计说明",
      "prop": "designDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写设计说明",
      "rows": "5",
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.curdForm.designDesc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "designDesc", $$v)
      },
      expression: "curdForm.designDesc"
    }
  })], 1)], 1), _vm._v(" "), (_vm.viewAreaVisible) ? _c('div', [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学号"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData ? _vm.selectRowData.stuCode : ''))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData ? _vm.selectRowData.stuName : ''))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学年学期"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.selectRowData ? _vm.selectRowData.semesterName : '') + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课题名称"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.selectRowData ? _vm.selectRowData.projectName : '') + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设计说明"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "110px",
      "overflow-y": "auto"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData ? _vm.selectRowData.designDesc : '') + "\n                    ")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attachmentVisible),
      expression: "attachmentVisible"
    }]
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.fileTableLoading),
      expression: "fileTableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fileTableData,
      "element-loading-text": "数据加载中",
      "height": _vm.fileTableHeight,
      "stripe": "",
      "border": "",
      "fit": ""
    },
    on: {
      "row-click": _vm.handleRowClick
    }
  }, [(_vm.operateAreaVisible) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件名",
      "prop": "fileName",
      "align": "center",
      "min-width": "40%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件类型",
      "prop": "fileType",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.operateAreaVisible),
            expression: "operateAreaVisible"
          }]
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.uploadDialogVisible = true
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v(" 上传")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": _vm.confirmDelFile
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除")])], 1), _vm._v(" "), (_vm.viewAreaVisible) ? _c('div', [_vm._v("操作")]) : _vm._e()]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showAttachment(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 预览\n                            ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.downloadAttachment(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v(" 下载\n                            ")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.auditAreaVisible) ? _c('div', {
    staticStyle: {
      "margin-bottom": "-25px"
    }
  }, [_c('audit', {
    ref: "audit",
    attrs: {
      "itemCode": _vm.queryForm.itemCode,
      "relatedCode": _vm.selectRowData.id,
      "auditLevel": _vm.selectRowData.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.operateAreaVisible),
      expression: "operateAreaVisible"
    }],
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitButtonVisible),
      expression: "submitButtonVisible"
    }],
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.submitRec
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "top": "50px"
    },
    attrs: {
      "title": "附件上传",
      "visible": _vm.uploadDialogVisible,
      "width": "520px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadDialogVisible = $event
      },
      "close": _vm.closeUploadDialog
    }
  }, [_c('div', {
    staticClass: "attachmentUpload",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-upload', {
    ref: "uploadFile",
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "#",
      "file-list": _vm.fileList,
      "http-request": _vm.getFile,
      "multiple": _vm.multipleType,
      "auto-upload": false,
      "limit": 10,
      "on-change": _vm.onChangeFile,
      "on-success": _vm.handleFilUploadSuccess,
      "on-remove": _vm.handleRemove,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                允许上传的文件类型如下（单个文件大小" + _vm._s(_vm.fileSizeLimit) + "MB以内）"), _c('br'), _vm._v("\n                                文本文件：txt、doc、docx、xls、xlsx、pdf、ppt、pptx"), _c('br'), _vm._v("\n                                图片文件：jpg、jpeg、png、gif"), _c('br'), _vm._v("\n                                音/视频文件：mp3、mp4\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    }
  }, [_vm._v("查看上传文件限制")])], 1)], 1)])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeUploadDialog
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "900px",
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.curdForm.id,
      "listHeight": 450
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.previewerVisible) ? _c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "widthPercent": 60,
      "heightNum": 650,
      "topNum": 60
    },
    on: {
      "closePreviewer": function($event) {
        _vm.previewerVisible = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55918a05"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scoreManage/register/graduateDesign.vue
// module id = 1831
// module chunks = 502